

import React, { useState } from 'react';
import Box from '@mui/material/Box';
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { Typography } from '@mui/material';

dayjs.extend(utc);
const DisplayUTDate = () => {
    const [utdate, setUtDate] = useState<string>()
    React.useEffect(() => {
        const ticker = setInterval( () => {
            setUtDate(dayjs.utc().format('YYYY-MM-DD H:mm:ss')) //remember to use ut date
        },1000);

        return () => {
            clearInterval(ticker)
        }
    },[])
    return (
        <Typography sx={{ color: '#ddd', }}>
            Current Time (UT): {utdate}
        </Typography>
    );
}

export default DisplayUTDate
